import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=3215e1b1&scoped=true&"
import script from "./academic.ts?vue&type=script&lang=ts&"
export * from "./academic.ts?vue&type=script&lang=ts&"
import style0 from "./academic.scss?vue&type=style&index=0&id=3215e1b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3215e1b1",
  null
  
)

export default component.exports